import { type Enum } from '@webapp/infrastructure/types/Enum'

// Route `:status` param values for /orders/approvals/:status (tab segments).
// Wire values — sent verbatim as the {status} path segment of
// GET /api/v2/orders/approvable/{status}/ and as the export payload `status`.
export const OrderApprovalTabs = {
  ALL: 'all', // All tab — combined queue, empty state omits the status word
  PENDING: 'pending', // Pending tab (default) — only tab with the bulk action bar
  APPROVED: 'approved', // Approved tab — read-only
  DENIED: 'denied', // Denied tab — read-only
} as const

export type OrderApprovalTab = Enum<typeof OrderApprovalTabs>
